module.exports = __webpack_public_path__ + "images/privateRoomLocked-147ee72c1526d8c139ec2fa95191bd91.png";